/**
 * Created by Daniela on 19/12/2016.
 */
import {AfterViewInit, Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { UtilService } from "../../../shared/services/util.service";
import { cercaModuleName, tiposCercas } from "../shared/data.service";
import { configuracaoModuleName, editRoute, newRouteFemale } from "../../../shared/services/data.service";
import { Cerca } from "../shared/cerca.model";
import { CercaApiService } from "../shared/cerca-api.service";
import { CercaService } from "../shared/cerca.service";
import { CercaNavigationService } from "../shared/cerca-navigation.service";
import { RastreamentoService } from "../../shared/rastreamento.service";
import { rastreamentosModuleName } from "../../shared/data.service";
import { ProjetoService } from "../../../projeto/shared/projeto.service";
import { DataService } from "../../../core/services/data.service";

declare var google: any;

@Component({
    template: require('./cerca-form.component.html'),
    styles: [require('./cerca-form.component.css')]
})
export class CercaFormComponent implements OnInit, AfterViewInit {
    cercaModule:any = cercaModuleName;
    formObject:any = new Cerca();
    actionTitle:string;
    submitted:boolean = false;
    btnSaveDisabled:boolean = false;
    configuracaoModule: any = configuracaoModuleName;
    module: any = rastreamentosModuleName;

    form:FormGroup;
    ativo = new FormControl('');
    nome = new FormControl('', Validators.required);
    raio = new FormControl('', Validators.required);
    tipo = new FormControl({value: '', disabled: true});
    latitude = new FormControl('', Validators.required);
    longitude = new FormControl('', Validators.required);

    private circle: any;
    private map: any;
    private projectLatLng: any;
    private draw: any;

    constructor(
        private _route:ActivatedRoute,
        private _utilService:UtilService,
        private _cercaService: CercaService,
        private _cercaApiService: CercaApiService,
        private _cercaNavigationService: CercaNavigationService,
        private _rastreamentoService: RastreamentoService,
        private _projetoService: ProjetoService,
        private _dataService: DataService,
        private _fb:FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            nome: this.nome,
            raio: this.raio,
            tipo: this.tipo,
            latitude: this.latitude,
            longitude: this.longitude
        });
    }

    ngOnInit() {
        let project = this._projetoService.getSessionStorage();
        if (project) {
            this.projectLatLng =  {lat: project.latitude, lng: project.longitude};
        } else {
            project = this._dataService.getCoordinates();
            this.projectLatLng =  {lat: project.lat, lng: project.lng};
        }

        this.initMap();
        this.testSession();
    }

    ngAfterViewInit() {
        this.formObject.tipo = this._utilService.cloneObject(tiposCercas[0].Value);
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.goToList();
    }

    clickGoToConfig() {
        this._rastreamentoService.goToSetting();
    }

    onSubmit(evt: any) {
        // this.submitted = true;

        if(evt.valid) {
            this.btnSaveDisabled = true;
            var object:any = this._utilService.cloneObject(this.formObject);

            if (this.formObject.id) {
                this.onEditCerca(object);
            } else {
                this.onAddCerca(object);
            }
        }
    }

    blurRadius() {
        if (this.formObject.raio) {
            this.circle.setRadius(Number(this.formObject.raio));
        }
    }

    blurLatLng() {
        if (this.formObject.latitude && this.formObject.longitude) {
            let latLng: any = {lat: Number(this.formObject.latitude), lng: Number(this.formObject.longitude)};
            this.circle.setCenter(latLng);
        }
    }

    private onAddCerca(object: Cerca) {
        this._cercaApiService.onPost(object, this.onDone);
    }

    private onEditCerca(object: Cerca) {
        this._cercaApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }
            this.goToList();
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setCircle();
                this.setDraw();

                this.map.setCenter({lat: this.formObject.latitude, lng: this.formObject.longitude});
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma cerca encontrada com este id.');
                this.goToList();
            }
        }.bind(this));

        this._cercaApiService.onGetById(id, onDone);
    }

    private goToList() {
        this._cercaService.clearSessionStorage();
        this._cercaNavigationService.goToList();
    }

    private testSession() {
        let id: number = +this._route.snapshot.params['id'];
        if (id) {
            this.actionTitle = editRoute;
            this.getObject(id);
        } else {
            this.actionTitle = newRouteFemale;
            this.setCircle();
            this.setDraw();
        }
    }

    private initMap() {
        const latLng = this.projectLatLng;
        const map = new google.maps.Map(document.getElementById('map'), {
            center: latLng,
            zoom: 12,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            }
        });

        const formContent: any = document.getElementById('form_content');
        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(formContent);

        this.map = map;
        this.setSeachBox();
    }

    private setCircle() {
        const options: any = {
            fillColor: '#4C87FF',
            fillOpacity: 0.5,
            strokeColor: '#4C87FF',
            strokeWeight: 1,
            clickable: true,
            editable: true,
            draggable: true,
            zIndex: 1
        };

        if (this.formObject.id) {
            if (this.formObject.raio) {
                options.radius = this.formObject.raio;
            } else {
                options.radius = 100;
            }

            if (this.formObject.latitude && this.formObject.longitude) {
                options.center = {lat: this.formObject.latitude, lng: this.formObject.longitude};
            } else {
                options.center = this.projectLatLng;
            }

            options.map = this.map;
        }

        const circle: any = new google.maps.Circle(options);

        google.maps.event.addListener(circle, 'radius_changed', () =>  {
            this.setRadius();
        });

        google.maps.event.addListener(circle, 'dragend', () =>  {
            this.setLatLng();
        });

        this.circle = circle;

        if (options.radius < 500) {
            this.map.setZoom(16);
        }
    }

    private setDraw() {
        const map = this.map;
        const circle = this.circle;

        const drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.CIRCLE,
            circleOptions: circle,
            drawingControl: false
        });

        let btn1: any = document.getElementById('btnHandDraw');
        let btn2: any = document.getElementById('btnDraw');
        let btn3: any = document.getElementById('btnRemoveDraw');

        btn1.addEventListener('click', (e: any) => {
            drawingManager.drawingMode = null;
            drawingManager.setMap(map);
        });

        btn2.addEventListener('click', (e: any) => {
            btn3.click();
            drawingManager.drawingMode = google.maps.drawing.OverlayType.CIRCLE;
            drawingManager.setMap(map);
        });

        btn3.addEventListener('click', (e: any) => {
            this.circle.setMap(null);
            btn1.click();
        });

        google.maps.event.addListener(drawingManager, 'circlecomplete', (circle: any) => {
            this.circle = circle;

            this.setRadius();
            this.setLatLng();

            btn1.click();
        });

        let btn: any = document.getElementById('drawOptions');
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(btn);

        if (!this.formObject.id) {
            drawingManager.setMap(map);
        }

        this.draw = drawingManager;
        //btn1.click();
    }

    private setSeachBox() {
        const map = this.map;

        const input = document.getElementById('pac-input');
        const searchBox = new google.maps.places.SearchBox(input);
        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(input);
        map.addListener('bounds_changed', function() {
            searchBox.setBounds(map.getBounds());
        });

        searchBox.addListener('places_changed', function() {
            const places = searchBox.getPlaces();

            if (places.length == 0) {
                return;
            }

            const bounds = new google.maps.LatLngBounds();
            places.forEach(function(place) {
                if (!place.geometry) {
                    return;
                }

                if (place.geometry.viewport) {
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }
            });
            map.fitBounds(bounds);
        });
    }

    private setRadius() {
        if (this.circle) {
            let radius = this.circle.getRadius();
            if (radius) {
                this._utilService.setSelectOnFormControl(this.form, 'raio', radius.toString());
                this.formObject.raio = parseInt(radius);

                let e: any = document.getElementById('raio');
                e.value = this.formObject.raio;
            }
        }
    }

    private setLatLng() {
        if (this.circle) {
            let circle: any = this.circle;
            this._utilService.setSelectOnFormControl(this.form, 'latitude', circle.getCenter().lat());
            this._utilService.setSelectOnFormControl(this.form, 'longitude', circle.getCenter().lng());
            this.formObject.latitude = circle.getCenter().lat();
            this.formObject.longitude = circle.getCenter().lng();

            let e: any = document.getElementById('latitude');
            e.value = this.formObject.latitude;

            e = document.getElementById('longitude');
            e.value = this.formObject.longitude;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/cercas/cerca-form/cerca-form.component.ts
 **/